<template>
  <div class="contents">
    <h1>Not Found</h1>
    <div class="contents__err">
      <span>{{ id }}</span>

      <router-link to="/" tag="button" class="btn-go-home">GO BACK TO HOME</router-link>
    </div>
  </div>
</template>

<script>
import callAPI from "../../api/http";
export default {
  props: ["id"]
};
</script>



// WEBPACK FOOTER //
// src/components/contents/NotFound.vue